<template>
    <div>
        <div id="signAndAccept" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Send for Signing</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-4">Enter your name as you would like it to appear on the agreement</div>
                            <div class="form-group">
                                <label :class="{'text-red': form.errors.has('signed_name')}">Full Name</label>
                                <input v-model="form.signed_name" class="form-control"
                                       :class="{'border-red': form.errors.has('signed_name')}" type="text">
                                <div class="text-red text-xs" v-if="form.errors.has('signed_name')">
                                    {{ form.errors.get('signed_name') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label :class="{'text-red': form.errors.has('email_at_signing')}">Email</label>
                                <input v-model="form.email_at_signing" class="form-control"
                                       :class="{'border-red': form.errors.has('email_at_signing')}" type="text">
                                <div class="text-red text-xs" v-if="form.errors.has('email_at_signing')">
                                    {{ form.errors.get('email_at_signing') }}
                                </div>
                            </div>
                            <input v-model="form.i_agree" class="mr-2" type="checkbox">
                            <span>
                                I agree that the signature will be the electronic representation of my signature for all purposes when I (or my agent) use
                                them on documents, inluding legally binding documents, just the same as pen-and-paper signature.
                            </span>
                            <div v-if="form.errors.has('i_agree')" class="text-red text-xs">
                                You must agree to the condition.
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="signAndAccept"
                                class="btn btn-outline-primary rounded-full">
                            Sign Quote
                        </button>
                    </div>
                </div>
            </div>
        </div>

<!--        <div v-if="tempProposal.locked && locked">-->
        <div v-if="!signNowfieldNotFound">
        <div v-if="!generating">
<!--            <div class="mb-4 text-right"  v-if="forWhat == 'signing' && !signNowLink && !proposal.form_field">-->
<!--                <button @click.prevent="openSignAndAcceptModal(proposal)"-->
<!--                        class="btn btn-outline-primary rounded-full">-->
<!--                    Sign & Accept-->
<!--                </button>-->
<!--            </div>-->
            <div class="mb-4 text-right"  v-if="forWhat == 'preview' && !proposal.form_field && isAppleDevice()">
                <button @click.prevent="openPdfForAppleDevices()"
                        class="btn btn-outline-primary rounded-full">
                    Open PDF For iPhone
                </button>
            </div>

            <!-- <div class="mb-4 text-right"  v-if="forWhat == 'signing' && !signNowLink && proposal.form_field">
                <button @click.prevent="saveAndGenerateSigningLink()"
                        class="btn btn-outline-primary rounded-full">
                    Save & Generate Signing Link
                </button>
            </div> -->
            <div v-if="!signNowLink" id="viewerContainer" style="width: 100% !important" />
<!--            <div id="editor-control-container" style="width:100% !important;height:150vh !important" v-if="proposal.form_field && !signNowLink"></div>-->
<!--            <embed-->
<!--                v-if="proposal.form_field && !signNowLink && proposal.pdf_filler_url && !formFilled"-->
<!--                :src="proposal.pdf_filler_url+'#view=FitH'"-->
<!--                type="application/pdf"-->
<!--                width="100%"-->
<!--                class="pdf-object"-->
<!--                height="1000vh">-->
<!--            </embed>-->

<!--            <embed-->
<!--                v-if="!signNowLink && !proposal.form_field"-->
<!--                :src="pdf+'#view=FitH'"-->
<!--                type="application/pdf"-->
<!--                width="100%"-->
<!--                class="pdf-object"-->
<!--                height="1000vh">-->
<!--            </embed>-->

            <iframe v-if="proposal.form_field && !signNowLink && proposal.pdf_filler_url && !formFilled" style="width: 100%; height:100%; min-height:100vh" :src="proposal.pdf_filler_url+'#view=FitH'"></iframe>
            <iframe v-if="!signNowLink && !proposal.form_field" style="width: 100%; height:100%; min-height:100vh" :src="pdf+'#view=FitH'"></iframe>
            <div v-else-if="forWhat == 'signing' && signNowLink" style="padding-bottom:56.25%; position:relative; display:block; width: 100%">
                <iframe  class="responsive-iframe" :src="signNowLink" frameborder="0" allowfullscreen="" style="position:absolute; top:0; left: 0;height: 70vh"></iframe>
            </div>
<!--            <embed-->
<!--                v-else-if="forWhat !== 'signing'"-->
<!--                :src="pdf+'#view=FitH'"-->
<!--                type="application/pdf"-->
<!--                width="100%"-->
<!--                class="pdf-object"-->
<!--                height="1000vh">-->
<!--            </embed>-->
            <iframe v-else-if="forWhat !== 'signing'" style="width: 100%; height:100%; min-height:100vh" :src="pdf+'#view=FitH'"></iframe>

<!--            <div v-else-if="forWhat !== 'signing'" id="viewerContainer" style="width: 100% !important" />-->
        </div>
        <div v-else class="justify-center mt-24 text-center">
            <img src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/loadingRadius.gif">
            <br>
            <h1>Generating Proposal Document Please Wait</h1>
        </div>
        <div v-if="formFilled" class="justify-center mt-24 text-center">
            <img src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/loadingRadius.gif">
            <br>
            <h1>Generating Proposal Signing Link. Please Wait</h1>
        </div>
        </div>
        <div v-else>
            <div class="flex flex-col text-center" style="display: block; text-align: center; margin-top: 20px;">
                <div>
                    <div class="text-2xl mb-2" style="display: block; width: 100%; text-align: center;">The quote is filled! Thank you!</div>
                    A copy of it will be sent to your email.<br>
                    Please check your email and remember to keep a copy for your records.
                </div>
                <div class="mt-4" style="margin-top:40px;">
                    <img width="500" src="/images/completed.svg">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Form from "../../utils/form";
import axios from "axios";

export default {
    name: "proposal-generator-prizm-viewer",
    components: {Form},
    props: ['proposal', 'signer', 'team', 'pdf', 'documentId', 'assetPath', 'forWhat', 'signNowLink'],
    data() {
        return {
            viewerEditor: null,
            tempProposal: this.proposal,
            form: new Form({
                proposalToken: this.proposal.token,
                signerToken: this.signer.token,
                signed_name: null,
                email_at_signing:null,
                i_agree: false,
                client_ip:'',
                signature: []
            }),
            locked: true,
            generating: this.proposal.generating,
            editorConnectors: null,
            docEditor: null,
            onlyOfficeCallBackUrl: window.location.origin+"/only-office-callback-form-fill/"+this.proposal.id,
            documentKey: null,
            formFilled: false,
            signNowfieldNotFound: false,

        }
    },
    mounted() {
        let self = this;
        // document.addEventListener("DOMContentLoaded", function(){
        //     let options  = {
        //         documentID:     self.documentId,
        //         imageHandlerUrl:  '/pasnew',
        //         viewerAssetsPath: self.assetPath,
        //         resourcePath:     self.assetPath+'/img',
        //         language: viewerCustomizations.languages['en-US'],
        //         template: viewerCustomizations.template,
        //         icons:    viewerCustomizations.icons,
        //         uiElements: viewerCustomizations.uiElements,
        //         annotationsMode: "LayeredAnnotations"
        //     };
        //     self.viewerEditor = $('#viewerContainer').pccViewer(options);
        // });
        self.getIPFromAmazon();

        if(this.proposal.generating){
            this.getGeneratedProposal();
        }
        // if(this.proposal.form_field){
        //     this.loadOnyOfficePDFFiller();
        // }

        if(this.proposal.pdf_filler_url){
            this.checkIfFormIsFilled();
        }
        if(this.forWhat == 'preview' && this.isAppleDevice()){
            this.openPdfForAppleDevices();
        }

    },
    methods: {
        openSignAndAcceptModal() {
            if(this.form.signerToken == null){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please login to sign and accept the proposal.'
                });
                setTimeout(function(){ window.location.href = "/login"; },5000);
                return false;
            }
            $("#signAndAccept").modal('show');
        },
        signAndAccept() {
            let self = this;

            if(self.viewerEditor){
                if(self.viewerEditor.viewerControl){
                    if(self.viewerEditor.viewerControl.getAllMarks().length > 0){
                        let marks = self.viewerEditor.viewerControl.getAllMarks()
                        marks.forEach(item => {
                            if(item.type == 'FreehandSignature'){
                                self.form.signature.push({
                                    type: item.type,
                                    path: item.path,
                                    rectangle: item.rectangle,
                                    color: item.color,
                                    thickness: item.thickness,
                                    pageNumber: item.pageNumber,
                                    interactionMode: item.interactionMode,
                                    horizontalAlignment: item.horizontalAlignment
                                });
                            }else{
                                self.form.signature.push({
                                    type: item.type,
                                    path: item.path,
                                    rectangle: item.rectangle,
                                    color: item.color,
                                    thickness: item.thickness,
                                    pageNumber: item.pageNumber,
                                    interactionMode: item.interactionMode,
                                    text: item.text,
                                    fontName: item.fontName
                                });
                            }
                        });
                    }
                    // else{
                    //     self.getToast().fire({
                    //         type: 'error',
                    //         title: 'Please add signature.'
                    //     });
                    // }
                }
            }

            this.form.post('/proposal/sign-and-accept')
                .then((response) => {
                    if (response.status === 'success') {
                        $("#signAndAccept").modal('hide');
                        window.location = response.redirect;
                    } else {
                        $("#signAndAccept").modal("hide");
                        self.getToast().fire({
                            type: 'error',
                            title: response.message
                        });
                        self.locked = false;
                    }
                });
        },
        getIPFromAmazon() {
            fetch('https://api.ipify.org?format=json')
                .then(x => x.json())
                .then(({ ip }) => {
                    this.form.client_ip = ip;
                    this.updateProposalOpen();
                });
        },
        updateProposalOpen(){
            axios.post('update-proposal-open', {proposal: this.proposal.id, ip:this.form.client_ip});
        },
        getGeneratedProposal(){
            axios.post(route('proposal.check-generating'), {proposalId: this.proposal.id}).then(
                (response) => {
                    if(!response.data.generating){
                        window.location.reload();
                    }else{
                        setTimeout(() => {
                            this.getGeneratedProposal();
                        }, 1500);
                    }
                }
            );
        },
        loadOnyOfficePDFFiller(){
            let self = this;
            let documentKey = self.makeid(10);
            this.documentKey = documentKey;
            const config = {
                document: {
                    fileType: "pdf",
                    key: this.documentKey,
                    title: "Quote.pdf",
                    url: this.pdf,
                    permissions: {
                        "edit": false,
                        "fillForms": true
                    }
                },
                documentType: "pdf",
                editorConfig: {
                    callbackUrl: this.onlyOfficeCallBackUrl,
                    mode: "edit",
                    customization: {
                        uiTheme: 'theme-followup',
                        customer: {
                            name: 'FollowupCRM',
                            logo: 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png'
                        },
                        forcesave: true,
                        logo: {
                            image: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            imageDark: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            url: "https://app.followupcrm.com/"
                        },
                        plugins: true,
                        unit: 'inch',
                        anonymous: {
                            request: true,
                            label: "Guest"
                        },
                        hideRightMenu: true
                    }
                },
                height: "900px",
                width: "100%"
            };
            this.docEditor = new DocsAPI.DocEditor("editor-control-container", config);
            this.$nextTick(() => {
                this.setEventsForOnlyOffice();
            });
        },
        setEventsForOnlyOffice(){
            this.editorConnectors = this.docEditor.createConnector();
        },
        makeid(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        saveAndGenerateSigningLink(){
            axios.post(route('proposal.only-office.save-document.fill-form'), {documentKey: this.documentKey})
                .then((response) => {
                    if(fromWhere){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                    Bus.$emit('changeReviewButtonPrizm', true);
                    this.$parent.savingPrizmDoc = 'Saved';
                });
        },
        checkIfFormIsFilled(){
            axios.post(route('proposal.check-if-form-is-filled'), {proposalId: this.proposal.id}).then(
                (response) => {
                    if(response.data.filled){
                        this.formFilled = true;
                        this.checkIfSignNowLinkIsReady();
                    }else{
                        setTimeout(() => {
                            this.checkIfFormIsFilled();
                        }, 1500);
                    }
                }
            );
        },
        checkIfSignNowLinkIsReady(){
            axios.post(route('proposal.check-signnow-link'), {proposalId: this.proposal.id}).then(
                (response) => {
                    if(response.data.sign_now_sign_url && !this.signNowLink){
                        window.location.reload();
                    }else if(response.data.sign_now_field_not_found && !this.signNowLink){
                        this.signNowfieldNotFound = true;
                    }else{
                        if(!this.signNowLink){
                            setTimeout(() => {
                                this.checkIfSignNowLinkIsReady();
                            }, 1500);
                        }
                    }
                }
            );
        },
        isAppleDevice() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        },
        openPdfForAppleDevices() {
            if (this.isAppleDevice()) {
                window.open(this.pdf, '_blank');
            }
        }
    },
}
</script>
<style scoped>
    .reports-frame-style {
        height: 100vh;
        width: 100%;
        border: 1px solid grey;
        border-radius: 7px;
    }

    input#algolia-search-box {
        width: 90%;
    }
    @media (max-width: 768px) {
        object {
            height: 400px; /* Adjust height for smaller screens */
        }
    }
</style>
<style>
    .responsive-iframe {
        width: 100%;
        height: 100vh;
    }
    .pdf-object {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        display: block;
    }
</style>
